export const asString = (v) => (v == null ? "" : String(v));
export const asStringArray = (v) => (Array.isArray(v) ? v : []);
export const asRadioString = (v) => (v == null ? "" : String(v));
